import { useState } from 'react'

export const useDragAndDrop = <T extends { id: string }>() => {
    const [currentItem, setCurrentItem] = useState<T | null>(null)

    const [highlited, setHighlited] = useState<string | null>(null)

    const onDragStartHandler = (_: unknown, item: T) => {
        setCurrentItem(item)
    }
    const onDragLeaveHandler = (_: unknown, id: string) => {
        setHighlited(null)
    }
    const onDragEndHandler = (_: unknown) => {}
    const onDragOverHandler = (e: any, id: string) => {
        e.preventDefault()
        setHighlited(id)
    }

    return {
        currentItem,
        highlited,
        setCurrentItem,
        setHighlited,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler
    }
}
